import { createClient } from "@supabase/supabase-js";

const ANON_KEY_STORAGE = "scheduler_supabase_key";

const decodeSupabaseKey = (key) => {
  if (!key || typeof key !== "string") return null;
  const trimmed = key.trim();
  if (trimmed.startsWith("eyJ")) return trimmed;

  try {
    const decoded = atob(trimmed);
    if (decoded.startsWith("eyJ")) return decoded;
  } catch {
    // Not base64 — use as-is below.
  }

  return trimmed;
};

const getSupabaseUrlFromKey = (anonKey) => {
  try {
    const payloadPart = anonKey.split(".")[1];
    if (!payloadPart) return null;
    const payload = JSON.parse(atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")));
    if (payload.ref) return `https://${payload.ref}.supabase.co`;
  } catch {
    // ignore malformed JWT payload
  }
  return process.env.REACT_APP_SUPABASE_URL || null;
};

const getStoredAnonKey = () => {
  try {
    return decodeSupabaseKey(sessionStorage.getItem(ANON_KEY_STORAGE));
  } catch {
    return null;
  }
};

const createSupabaseClient = (anonKey) => {
  const url = getSupabaseUrlFromKey(anonKey);
  if (!url || !anonKey) {
    throw new Error("Supabase client is not configured");
  }

  return createClient(url, anonKey, {
    auth: {
      storage: typeof localStorage !== "undefined" ? localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
};

let supabaseInstance = null;
let activeKey = null;

const getSupabase = () => {
  const anonKey = getStoredAnonKey();
  if (!anonKey) {
    throw new Error("Supabase anon key is not available");
  }
  if (!supabaseInstance || anonKey !== activeKey) {
    supabaseInstance = createSupabaseClient(anonKey);
    activeKey = anonKey;
  }
  return supabaseInstance;
};

const setSupabaseAnonKey = (anonKey) => {
  const decodedKey = decodeSupabaseKey(anonKey);
  if (!decodedKey) return;

  try {
    sessionStorage.setItem(ANON_KEY_STORAGE, decodedKey);
  } catch {
    // ignore blocked storage access
  }

  if (decodedKey !== activeKey) {
    supabaseInstance = createSupabaseClient(decodedKey);
    activeKey = decodedKey;
  }
};

export {
  getSupabase,
  setSupabaseAnonKey,
};
